// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"37":"c2b15000d19f37b85cbc","588":"a6faaecc7264b636e5b6"}[chunkId] + ".js?v=" + {"37":"c2b15000d19f37b85cbc","588":"a6faaecc7264b636e5b6"}[chunkId] + "";
};